import { inject, Injectable } from '@angular/core';
import { TimestampIsInCurrentMinute } from '@core/constants/time.defaults';
import {
  SetRealtimeFlagAction,
  SetSystemDatesAction,
  SetToDateIntervalAction,
} from '@dashboard/dashboard-store/actions';
import { ToDateSelector } from '@dashboard/dashboard-store/selectors';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, of, switchMap, withLatestFrom } from 'rxjs';
@Injectable()
export class WsEffects {
  private actions$ = inject(Actions);
  private _store = inject(Store);

  HandleRealtimeFlag$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SetSystemDatesAction),
      withLatestFrom(this._store.select(ToDateSelector)),
      switchMap(([, toDate]) => {
        const isRealTime = TimestampIsInCurrentMinute(toDate);
        return of(SetRealtimeFlagAction({ enableRealtime: isRealTime }));
      })
    );
  });

  HandleToDateInterval$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SetToDateIntervalAction),
      filter(({ updateState }) => updateState),
      switchMap(({ toDate }) => {
        // When updateState is true, dispatch SetSystemDatesAction to inform the app
        console.log(
          'To date interval updated, syncing to system dates:',
          toDate
        );
        return of(SetSystemDatesAction({ toDate }));
      })
    );
  });
}
